import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    selector: 'k2-icon',
    templateUrl: 'k2-icon.component.html',
    styleUrls: ['k2-icon.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class K2IconComponent {
  @Input() link: any;
}
